import { render, staticRenderFns } from "./moduleBox.vue?vue&type=template&id=12c589e8&scoped=true&"
import script from "./moduleBox.vue?vue&type=script&lang=js&"
export * from "./moduleBox.vue?vue&type=script&lang=js&"
import style0 from "./moduleBox.vue?vue&type=style&index=0&id=12c589e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c589e8",
  null
  
)

export default component.exports